import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {translations} from 'presentation/translations-new';
import {GetNotFoundContentParams} from './types';
import {BookingNotFoundVariantEnum} from '../../types';

const {state, city, locality, consultNetworkProviderHealth, consultNetworkProviderOdonto} =
	translations['pt-br'].privateFlow.profile.locationSelection;
const {specialtyFlow, unitsFlow, districtFlow} = translations['pt-br'].privateFlow.bookingFlow;

export const getNotFoundContent = ({variant, flowType}: GetNotFoundContentParams) => {
	const isExam = flowType === FlowEnum.EXAM;
	const isOdonto = flowType === FlowEnum.ODONTO;
	const descriptions = getDescriptions(flowType);

	const contentMap = {
		[BookingNotFoundVariantEnum.CITY]: {
			headerTitle: city.notFoundModal.headerTitle,
			title: city.notFoundModal.title,
			description: descriptions.cityDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.UF]: {
			headerTitle: state.notFoundModal.headerTitle,
			title: state.notFoundModal.title,
			description: descriptions.stateDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.SPECIALTY]: {
			headerTitle: isExam
				? specialtyFlow.notFoundModal.examHeaderTitle
				: specialtyFlow.notFoundModal.headerTitle,
			title: isExam
				? specialtyFlow.notFoundModal.examTitle
				: specialtyFlow.notFoundModal.title,
			description: descriptions.specialtyDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.DISTRICT]: {
			headerTitle: districtFlow.notFoundModal.headerTitle,
			title: districtFlow.notFoundModal.title,
			description: descriptions.districtDescription,
			modalActionButton: isOdonto
				? consultNetworkProviderOdonto
				: consultNetworkProviderHealth,
		},
		[BookingNotFoundVariantEnum.UNIT]: {
			headerTitle: unitsFlow.notFoundModal.headerTitle,
			title: unitsFlow.notFoundModal.title,
			description: descriptions.unitsFlowDescription,
			modalActionButton: descriptions.guideButtonLabel,
		},
		[BookingNotFoundVariantEnum.LOCALITY]: {
			headerTitle: locality.notFoundModal.headerTitle,
			title: locality.notFoundModal.title,
			description: descriptions.localityDescription,
			modalActionButton: consultNetworkProviderHealth,
		},
	};

	return contentMap[variant];
};

const getDescriptions = (flowType: FlowEnum) => {
	const isOdonto = flowType === FlowEnum.ODONTO;

	if (!isOdonto) {
		return {
			guideButtonLabel: consultNetworkProviderHealth,
			cityDescription: city.notFoundModal.descriptionNetworkProvider,
			stateDescription: state.notFoundModal.descriptionNetworkProvider,
			specialtyDescription: specialtyFlow.notFoundModal.descriptionNetworkProvider,
			unitsFlowDescription: unitsFlow.notFoundModal.descriptionNetworkProvider,
			localityDescription: locality.notFoundModal.descriptionNetworkProvider,
			districtDescription: districtFlow.notFoundModal.descriptionAllHealth,
		};
	}

	return {
		guideButtonLabel: consultNetworkProviderOdonto,
		cityDescription: city.notFoundModal.descriptionNetworkProviderDental,
		stateDescription: state.notFoundModal.descriptionNetworkProviderDental,
		specialtyDescription: specialtyFlow.notFoundModal.descriptionNetworkProviderDental,
		unitsFlowDescription: unitsFlow.notFoundModal.descriptionNetworkProviderDental,
		localityDescription: locality.notFoundModal.descriptionNetworkProvider,
		districtDescription: districtFlow.notFoundModal.descriptionAll,
	};
};
